export default __webpack_public_path__ + "static/media/mobility-scooter-hire.inline.3deb2a98.svg";